module.exports = __webpack_public_path__ + "static/media/1023167.457ec507.png";